import { render } from "./JoiningIntention.vue?vue&type=template&id=4b18ca5b&scoped=true"
const script = {}

import "./JoiningIntention.vue?vue&type=style&index=0&id=4b18ca5b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wesle\\Projects\\playco-cn\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b18ca5b"]])

export default __exports__